import { render, staticRenderFns } from "./_userStaffControls.vue?vue&type=template&id=78f930c3"
import script from "./_userStaffControls.vue?vue&type=script&lang=js"
export * from "./_userStaffControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports